"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFormattedDate = void 0;
/**
 * Returns a formatted date string in the format 'YYYY-MM-DD'.
 * If a date is provided, it will format that date; otherwise, it will use the current date.
 *
 * @param {Date} [date] - The optional Date object to format. If not provided, the current date is used.
 * @returns {string} The formatted date string in the 'YYYY-MM-DD' format.
 */
const getFormattedDate = (date) => {
    const today = date || new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0"); // Add 1 because months are zero-indexed
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
};
exports.getFormattedDate = getFormattedDate;
